import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'
import { Button, Form, Input, InputNumber, Modal, Pagination, Space, Table, Typography } from 'antd'
import { isEmpty } from 'lodash'
import { observer } from 'mobx-react-lite'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
// @ts-ignore
import ReactExport from 'react-data-export'
import { useTranslation } from 'react-i18next'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { PAGE_SIZE } from 'src/helpers/constants'
import { showMessageSuccess } from 'src/helpers/functions'
import { useStore } from 'src/hooks'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

interface Item {
   createdAt?: string
   deletedAt?: string
   productId: any
   productName: string
   sku: string
   productIdDelivery?: string
   hasCode?: string
   variantId?: string
   length?: string
   width?: string
   height?: string
   id?: number
}

const ContentFee: React.FC = observer((props: any) => {
   const [form] = Form.useForm()
   const [editingKey, setEditingKey] = useState('')
   const [isImporting, setIsImporting] = useState(false)
   const inputFileRef = useRef<HTMLInputElement>(null)
   const { t } = useTranslation()
   const UserStore = useStore('UserStore')
   const OrdersStore = useStore('OrdersStore')
   const { rows } = OrdersStore.listShippingData
   const { results, totalResults, page } = UserStore.listCreator

   useEffect(() => {
      setEditingKey('')
      OrdersStore.getListDeliveryMaping(props.idTab)
   }, [props?.idTab])

   const isEditing = (record: Item) => record.productId?.toString() === editingKey

   const edit = (record: Partial<Item> & { productId: React.Key }) => {
      form.setFieldsValue({ ...record })
      console.log(' recor ban dau', JSON.stringify(record))
      // form.setFieldsValue({
      //    sku: record.sku,
      //    productIdDelivery: record.productIdDelivery,
      //    hasCode: record.hasCode,
      //    productName: record.productName,
      //    variantId: record.variantId,
      // })
      setEditingKey(record.productId + '')
   }

   const cancel = () => {
      setEditingKey('')
   }

   const save = async (record: Item) => {
      console.log('[save] record', JSON.stringify(record))

      try {
         const row = (await form.validateFields()) as Item

         const newData = [...rows]
         const index = newData.findIndex((item) => record?.productId === item.productId)

         if (index > -1) {
            const item = newData[index]
            const updatedItem = { ...item, ...row }

            OrdersStore.updateDeliveryMaping(props.idTab, {
               productId: updatedItem.productId + '',
               sku: updatedItem.sku,
               productIdDelivery: updatedItem.productIdDelivery + '',
               hasCode: updatedItem.hasCode,
               productName: updatedItem.productName,
               variantId: updatedItem.variantId,
               length: updatedItem.length,
               width: updatedItem.width,
               height: updatedItem.height
            })

            newData.splice(index, 1, updatedItem)
            OrdersStore.setListDeliveryMaping(newData)
            setEditingKey('')
         }
      } catch (err) {
         // handle error
      }
   }

   let columns = [
      {
         title: 'ID',
         dataIndex: 'productId',
         key: 'productId',
         width: '20%',
         editable: false,
         render: (value: any) => {
            return <span className="txtMax2Line">{value}</span>
         }
      },
      {
         title: 'Tên sản phẩm',
         dataIndex: 'product',
         key: 'product',
         width: '20%',
         editable: false,
         render: (value: any) => {
            return <span className="txtMax2Line">{value?.name}</span>
         }
      },
      {
         title: 'SKU',
         dataIndex: 'skuGroup',
         key: 'skuGroup',
         width: '40%',
         editable: false,
         render: (_: any, record: any) => {
            const editable = isEditing(record)
            return editable ? (
               <div style={{ padding: 16 }}>
                  <Form.Item name="sku" style={{ marginBottom: 4 }} label="SKU">
                     <Input placeholder="SKU" />
                  </Form.Item>
                  <Form.Item name="productIdDelivery" label="Product ID" style={{ marginBottom: 4 }}>
                     <Input placeholder="Product ID" />
                  </Form.Item>
                  <Form.Item name="hasCode" label="Has Code" style={{ marginBottom: 4 }}>
                     <Input placeholder="Has Code" />
                  </Form.Item>
                  <Form.Item name="productName" label="Product Name" style={{ marginBottom: 4 }}>
                     <Input placeholder="Product Name" />
                  </Form.Item>
                  <Form.Item name="variantId" label="Variant ID" style={{ marginBottom: 4 }}>
                     <Input placeholder="Variant ID" />
                  </Form.Item>
                  <Form.Item name="width" label="Width" style={{ marginBottom: 4 }}>
                     <InputNumber placeholder="Width" maxLength={20} />
                  </Form.Item>
                  <Form.Item name="height" label="Height" style={{ marginBottom: 4 }}>
                     <InputNumber placeholder="Height" maxLength={20} />
                  </Form.Item>
                  <Form.Item name="length" label="Length" style={{ marginBottom: 0 }}>
                     <InputNumber placeholder="Length" maxLength={20} />
                  </Form.Item>
               </div>
            ) : (
               <div className="">
                  <div>
                     <strong>SKU:</strong> {record.sku}
                  </div>
                  <div>
                     <strong>Product ID:</strong> {record.productIdDelivery}
                  </div>
                  <div>
                     <strong>Has Code:</strong> {record.hasCode}
                  </div>
                  <div>
                     <strong>Product Name:</strong> {record.productName}
                  </div>
                  <div>
                     <strong>Variant ID:</strong> {record.variantId}
                  </div>
                  <div>
                     <strong>Width:</strong> {record.width}
                  </div>
                  <div>
                     <strong>Height:</strong> {record.height}
                  </div>
                  <div>
                     <strong>Length:</strong> {record.length}
                  </div>
               </div>
            )
         }
      },
      {
         title: 'Action',
         width: '15%',
         align: 'center',
         dataIndex: 'operation',
         render: (_: any, record: Item) => {
            const editable = isEditing(record)
            return editable ? (
               <span>
                  <Typography.Link onClick={() => save(record)} style={{ marginRight: 8 }}>
                     {t(GLOBAL_CLIENT.save)}
                  </Typography.Link>
                  <Typography.Link onClick={cancel} style={{ marginRight: 8 }}>
                     {t(GLOBAL_CLIENT.huy)}
                  </Typography.Link>
               </span>
            ) : (
               <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                  {t(GLOBAL_CLIENT.edit)}
               </Typography.Link>
            )
         }
      }
   ]

   const onChange = (currentPage: number) => {
      // handle_getListData(currentPage)
   }

   const renderPagination = () => {
      if (isEmpty(results)) return null

      return (
         <div className="containerPagination">
            <Pagination
               onChange={onChange}
               pageSize={PAGE_SIZE}
               current={page}
               showSizeChanger={false}
               total={totalResults}
            />
         </div>
      )
   }

   const resetInputFile = () => {
      if (inputFileRef.current) {
         inputFileRef.current.value = ''
      }
   }

   // Gửi file lên server, server đọc file và cập nhật DB
   const handleImportExcel = (event: any) => {
      const file = event.target.files?.[0]
      if (!file) return

      Modal.confirm({
         title: 'Import Excel',
         content: `Cập nhật cấu hình ${props.idTab} từ file "${file.name}"?`,
         onOk: async () => {
            try {
               setIsImporting(true)
               const res = await OrdersStore.importDeliveryMaping(props.idTab, file)
               if (res?.data) {
                  const { updated, notFound } = res.data
                  showMessageSuccess(
                     `Đã cập nhật ${updated} sản phẩm` +
                        (isEmpty(notFound) ? '' : `. Không tìm thấy ID: ${notFound.join(', ')}`)
                  )
                  setEditingKey('')
                  OrdersStore.getListDeliveryMaping(props.idTab)
               }
            } finally {
               setIsImporting(false)
               resetInputFile()
            }
         },
         onCancel: resetInputFile
      })
   }

   const renderExport = () => {
      return (
         <Space style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
            <Button loading={isImporting} onClick={() => inputFileRef.current?.click()}>
               {'Nhập Excel'}
               <UploadOutlined />
            </Button>
            <input
               ref={inputFileRef}
               type="file"
               accept=".xlsx"
               style={{ display: 'none' }}
               onChange={handleImportExcel}
            />
            <ExcelFile
               element={
                  <Button disabled={isEmpty(rows)}>
                     {t(GLOBAL_CLIENT.exportExcel)}
                     <DownloadOutlined />
                  </Button>
               }
               filename={`Cấu hình vận chuyển ${props.idTab} ${moment().format('HH:mm:ss DD-MM-YYYY')}`}
            >
               <ExcelSheet data={rows || []} name={props.idTab || 'Shipping'}>
                  <ExcelColumn label={'ID'} value="productId" />
                  <ExcelColumn label={'Name'} value={(col: any) => col?.product?.name || ''} />
                  <ExcelColumn label={'SKU'} value={(col: any) => col?.sku || ''} />
                  <ExcelColumn label={'Product ID'} value={(col: any) => col?.productIdDelivery || ''} />
                  <ExcelColumn label={'Has Code'} value={(col: any) => col?.hasCode || ''} />
                  <ExcelColumn label={'Product Name'} value={(col: any) => col?.productName || ''} />
                  <ExcelColumn label={'Variant ID'} value={(col: any) => col?.variantId || ''} />
                  <ExcelColumn label={'Width'} value={(col: any) => col?.width ?? ''} />
                  <ExcelColumn label={'Height'} value={(col: any) => col?.height ?? ''} />
                  <ExcelColumn label={'Length'} value={(col: any) => col?.length ?? ''} />
               </ExcelSheet>
            </ExcelFile>
         </Space>
      )
   }

   return (
      <div>
         {renderExport()}
         <Form form={form} component={false}>
            <Table
               bordered
               dataSource={rows || []}
               // @ts-ignore
               columns={columns}
               rowClassName="editable-row"
               rowKey="productId"
               pagination={false}
            />
            {renderPagination()}
         </Form>
      </div>
   )
})

export default ContentFee
